import React, { useContext, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Collapse from "@material-ui/core/Collapse";

import { AnswerContext } from "../../index";
import { Container } from "./styles";

function StepSix() {
  const { state, dispatch, WizardContext } = useContext(AnswerContext);
  const { dispatch: wizardDispatch } = useContext(WizardContext);

  function handleChangePricing(event) {
    dispatch({
      type: "CHANGE_FIELD",
      field: "pricing",
      value: event.target.checked ? "HIGHEST_VALUE" : "default",
    });
  }

  function handleChangeFullPrice(event) {
    dispatch({
      type: "CHANGE_FIELD",
      field: "fullPrice",
      value: event.target.checked ? true : false,
    });
  }

  useEffect(() => {
    wizardDispatch({
      type: "SET_IS_COMPLETE",
      isComplete: state.required === null ? false : true,
    });
  }, [state]);

  return (
    <Container>
      <FormControlLabel
        style={{ marginTop: "20px" }}
        control={
          <Switch
            name="fullPrice"
            color="primary"
            checked={state.fullPrice}
            onChange={handleChangeFullPrice}
          />
        }
        label="É preço inteiro?"
      />
      <FormControlLabel
        style={{ marginTop: "20px" }}
        control={
          <Switch
            name="pricing"
            color="primary"
            checked={state.pricing === "HIGHEST_VALUE"}
            onChange={handleChangePricing}
          />
        }
        label="É cobrado pelo maior preço?"
      />
    </Container>
  );
}

export default StepSix;
